import { SystemColors } from "./colors";
import { alertTokens, alphaTokens, background, border, button, chartTokens, chip, extractFromMode, field, icon, progressBar, rangeSlider, shapeIcon, table, text, toggle } from "./colorTokens";
const primary = {
    main: SystemColors.primary["500"],
    dark: SystemColors.primary["700"]
};
const secondary = {
    main: SystemColors.accentBlue["500"],
    dark: SystemColors.accentBlue["700"]
};
const success = {
    main: SystemColors.success["500"],
    dark: SystemColors.success["700"]
};
const destructive = {
    main: SystemColors.error["500"],
    dark: SystemColors.error["700"]
};
const warning = {
    main: SystemColors.warning["500"],
    dark: SystemColors.warning["700"]
};
// These colors are not used and are just there for making sure MUI complies
const tertiary = {
    main: button["buttonPrimary"].light
};
const quarternary = {
    main: button["buttonPrimary"].light
};
const ghostGray = {
    main: button["buttonPrimary"].light
};
const ghostPrimary = {
    main: button["buttonPrimary"].light
};
const linkGray = {
    main: button["buttonPrimary"].light
};
const linkPrimary = {
    main: button["buttonPrimary"].light
};
const none = {
    main: SystemColors.gray["100"],
    contrastText: SystemColors.gray["900"]
};
const gray = {
    main: SystemColors.gray["100"],
    contrastText: SystemColors.gray["900"]
};
const neutral = {
    main: SystemColors.gray["100"],
    contrastText: SystemColors.gray["900"]
};
const light = {
    mode: "light",
    primary,
    secondary,
    success,
    error: destructive,
    destructive,
    warning,
    background: extractFromMode(background, "light"),
    text: extractFromMode(text, "light"),
    // Only for making sure things run
    tertiary,
    quarternary,
    ghostGray,
    ghostPrimary,
    linkGray,
    linkPrimary,
    gray,
    none,
    neutral,
    tokens: {
        alert: extractFromMode(alertTokens, "light"),
        background: extractFromMode(background, "light"),
        border: extractFromMode(border, "light"),
        button: extractFromMode(button, "light"),
        chip: extractFromMode(chip, "light"),
        field: extractFromMode(field, "light"),
        icon: extractFromMode(icon, "light"),
        progressBar: extractFromMode(progressBar, "light"),
        rangeSlider: extractFromMode(rangeSlider, "light"),
        table: extractFromMode(table, "light"),
        toggle: extractFromMode(toggle, "light"),
        text: extractFromMode(text, "light"),
        shapeIcon: extractFromMode(shapeIcon, "light"),
        alphaTokens: extractFromMode(alphaTokens, "light"),
        chart: extractFromMode(chartTokens, "light")
    }
};
export default light;

//# sourceMappingURL=light.js.map